import * as React from 'react';
import type { SVGProps } from 'react';
const SvgSavings = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={15}
    fill="none"
    viewBox="0 0 16 15"
    {...props}
  >
    <path
      fill="#5C78C7"
      d="M3.083 15q-.435 0-.842-.302-.408-.303-.533-.719a146 146 0 0 1-.833-2.906 35 35 0 0 1-.524-2.144 18 18 0 0 1-.27-1.64A12 12 0 0 1 0 5.917q0-1.813 1.333-3.115Q2.667 1.5 4.5 1.5h4.146Q9.229.792 10.125.396A4.6 4.6 0 0 1 12 0q.417 0 .708.292Q13 .583 13 1q0 .23-.062.396-.063.167-.105.264-.083.214-.187.382a1.2 1.2 0 0 0-.146.453l2 2.005h.77a.7.7 0 0 1 .52.219q.21.219.21.51v4.167a.8.8 0 0 1-.135.437.62.62 0 0 1-.365.271l-1.75.396-.958 3.438q-.15.484-.542.773t-.896.289H9.521q-.627 0-1.074-.396A1.3 1.3 0 0 1 8 13.584V13.5H6.5v.083q0 .625-.427 1.021A1.5 1.5 0 0 1 5.02 15zm.042-1.5H5V12h4.5v1.5h1.854l1.188-4.27 1.958-.438V6h-.625L11 3.125a5.6 5.6 0 0 1 .208-1.52q-.583.145-1.041.52-.459.375-.771.875H4.5q-1.188 0-2.094.906T1.5 6q0 1.125.427 2.917T3.125 13.5m8.12-6.5q.318 0 .536-.214A.71.71 0 0 0 12 6.254a.74.74 0 0 0-.214-.535.71.71 0 0 0-.532-.219.74.74 0 0 0-.535.214.71.71 0 0 0-.219.532q0 .316.214.535t.532.219M8.25 5.5q.319 0 .534-.214A.72.72 0 0 0 9 4.754a.73.73 0 0 0-.216-.535A.72.72 0 0 0 8.25 4h-2.5a.73.73 0 0 0-.534.214.72.72 0 0 0-.216.532q0 .316.216.535a.72.72 0 0 0 .534.219z"
    />
  </svg>
);
export default SvgSavings;
